"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconCustomRadioWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var FalconCustomRadioWidget = exports.FalconCustomRadioWidget = /** @class */ (function (_super) {
    __extends(FalconCustomRadioWidget, _super);
    function FalconCustomRadioWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLabelValue = function (value) {
            var result = journey_services_1.ExpressionEvaluator.renderTemplate(value, _this.props.interaction);
            if (result === "None") {
                if (_this.state.isMobileScreenSize) {
                    result = "0";
                }
            }
            return result;
        };
        _this.state = {
            lookupValues: [],
            isMobileScreenSize: window.innerWidth < 768
        };
        _this.inputRef = React.createRef();
        _this.handleChangeEvent = _this.handleChangeEvent.bind(_this);
        window.addEventListener("resize", _this.resize.bind(_this));
        _this.validate = _this.validate.bind(_this);
        return _this;
    }
    FalconCustomRadioWidget_1 = FalconCustomRadioWidget;
    FalconCustomRadioWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (this.getSetting(FalconCustomRadioWidget_1.classifier)) {
            this.lookupService.fetchLookupValues(this.getSetting(FalconCustomRadioWidget_1.classifier), "en-UK").subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues
                });
            });
        }
    };
    FalconCustomRadioWidget.prototype.renderInputField = function () {
        var _this = this;
        var radioButtons = [];
        if (this.state.lookupValues) {
            this.state.lookupValues.forEach(function (v) {
                return radioButtons.push(React.createElement("div", { className: "".concat(_this.getSetting(FalconCustomRadioWidget_1.inputBaseDivCssClass, "custom-control custom-radio"), " falcon-custom-radio"), key: v.id },
                    React.createElement("input", { className: "".concat(_this.getSetting(FalconCustomRadioWidget_1.inputCssClass, "custom-control-input"), " ").concat(_this.getInputValidationClass()), type: "radio", ref: _this.inputRef, name: _this.props.question.name, key: v.id, value: v.id, checked: _this.isChecked(v.id), onChange: _this.handleChangeEvent, onBlur: function (event) { return _this.validate(event); }, id: _this.props.question.name + v.id, disabled: _this.getSetting(FalconCustomRadioWidget_1.inputDisabledSetting, false) || _this.isReadOnly() }),
                    React.createElement("label", { id: _this.getSetting(FalconCustomRadioWidget_1.labelId, ""), className: _this.getSetting(FalconCustomRadioWidget_1.labelCssClass, "custom-control-label"), htmlFor: _this.props.question.name + v.id }, _this.renderLabelValue(v.value))));
            });
        }
        return (React.createElement(React.Fragment, null, radioButtons));
    };
    FalconCustomRadioWidget.prototype.validate = function (event) {
        this.executeNativeEvent(event);
        this.validateInternal(event.target.value);
    };
    ;
    FalconCustomRadioWidget.prototype.isChecked = function (id) {
        return (id === "".concat(this.bindFromField(this.props.question.interactionField)));
    };
    FalconCustomRadioWidget.prototype.handleChangeEvent = function (event) {
        _super.prototype.handleOnChangeEvent.call(this, event);
        this.validate(event);
    };
    FalconCustomRadioWidget.prototype.resize = function () {
        var currentIsMobile = (window.innerWidth < 768);
        if (currentIsMobile !== this.state.isMobileScreenSize) {
            this.setState({ isMobileScreenSize: currentIsMobile });
        }
    };
    var FalconCustomRadioWidget_1;
    FalconCustomRadioWidget.inputDisabledSetting = "inputDisabled";
    FalconCustomRadioWidget.classifier = "classifier";
    FalconCustomRadioWidget.inputBaseDivCssClass = "inputBaseDivCssClass";
    FalconCustomRadioWidget.inputCssClass = "inputCssClass";
    FalconCustomRadioWidget.labelCssClass = "labelCssClass";
    FalconCustomRadioWidget.labelId = "labelId";
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], FalconCustomRadioWidget.prototype, "lookupService", void 0);
    FalconCustomRadioWidget = FalconCustomRadioWidget_1 = __decorate([
        (0, journey_model_1.settings)([
            { name: "inputDisabled", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "classifier", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], FalconCustomRadioWidget);
    return FalconCustomRadioWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=FalconCustomRadioWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/FalconCustomRadioWidget.js
// module id = 3638
// module chunks = 0